module.exports = __webpack_public_path__ + "static/media/userdashboard.eceaa8b6.PNG";